/**
 * Агрегация «клиентов комплекса» по связям из заявок, абонементов, персональных и участников групп.
 */

export function normalizeListResponse(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.items)) return data.items;
  if (data && Array.isArray(data.results)) return data.results;
  if (data && Array.isArray(data.$values)) return data.$values;
  if (data && Array.isArray(data.data)) return data.data;
  return [];
}

export function getUserIdFromRequest(req) {
  if (req == null) return null;
  const u =
    req.userId != null
      ? req.userId
      : req.userID != null
        ? req.userID
        : req.UserId != null
          ? req.UserId
          : req.user && (req.user.id != null ? req.user.id : req.user.Id);
  if (u == null || u === '') return null;
  const n = Number(u);
  return Number.isNaN(n) ? null : n;
}

/**
 * @returns {{ userId: number, sources: string[] }[]}
 */
export function aggregateSectionClients(requests, abonements, personalTrainings, groupMembers = []) {
  const map = new Map();
  const add = (userId, source) => {
    if (userId == null || Number.isNaN(Number(userId))) return;
    const id = Number(userId);
    if (!map.has(id)) map.set(id, new Set());
    map.get(id).add(source);
  };

  (requests || []).forEach((r) => {
    const uid = getUserIdFromRequest(r);
    if (uid != null) add(uid, 'Заявка');
  });
  (abonements || []).forEach((a) => {
    const uid = a.userId != null ? a.userId : a.UserId;
    if (uid != null) add(uid, 'Абонемент');
  });
  (personalTrainings || []).forEach((p) => {
    const uid = p.userId != null ? p.userId : p.UserId;
    if (uid != null) add(uid, 'Персональная');
  });
  (groupMembers || []).forEach((m) => {
    const uid = m.userId != null ? m.userId : m.UserId;
    if (uid != null) add(uid, 'Группа');
  });

  return Array.from(map.entries())
    .map(([userId, sources]) => ({
      userId,
      sources: Array.from(sources).sort(),
    }))
    .sort((a, b) => a.userId - b.userId);
}

/** Подпись пользователя из webusers / member payload */
export function formatUserLabel(user) {
  if (!user) return '';
  const name = user.name || user.Name || user.userName || user.UserName || '';
  const email = user.email || user.Email || '';
  const phone = user.phoneNumber || user.PhoneNumber || user.phone || '';
  const parts = [name, email, phone].filter(Boolean);
  return parts.join(' · ') || `User #${user.id != null ? user.id : user.Id}`;
}
